<template>
  <div class="lg:flex lg:flex-col lg:items-center lg:pt-10 mt-6 lg:px-8 xl:px-16">
    <div class="bg-gradient-to-r from-teal-500 to-cyan-600 rounded-md pb-5 lg:pb-0 lg:pb-0 lg:z-10 lg:relative">
      <div class="lg:mx-auto lg:px-8 lg:grid lg:grid-cols-3 lg:gap-8">
        <div class="relative lg:-my-8">
          <div aria-hidden="true" class="absolute inset-x-0 top-0 h-1/2 bg-white lg:hidden" />
          <div class="mx-auto px-4 sm:max-w-7xl sm:px-6 lg:p-0 sm:h-full">
            <div class="aspect-w-8 aspect-h-6 rounded-xl shadow-xl overflow-hidden lg:aspect-none lg:h-full bg-black">
              <img
                  class="sm:object-fill lg:object-cover lg:h-full lg:w-full"
                  src="../../assets/images/wp2550138.jpeg" alt="" />
            </div>
          </div>
        </div>
        <div class="sm:mt-3 lg:mt-12 lg:m-0 lg:col-span-2 lg:pl-2">
          <div class="mx-auto px-4 px-6 lg:px-0 lg:py-32 lg:max-w-none">
            <div>
              <p class="mb-6 mt-1 font-creepster text-white text-5xl xl:text-6xl 2xl:text-7xl">
                Monster Slayer Game
              </p>
              <ul class="grid gap-12 grid-cols-2">
                <div class="relative pt-1">
                  <div class="flex mb-2 items-center justify-between">
                    <div>
                      <span class="lg:text-lg tracking-wider inline-block py-1 px-3 py-1 uppercase rounded-full text-pink-600 bg-pink-200 font-creepster">
                        Monster Health
                      </span>
                    </div>
                    <div class="text-right">
                        <span class="text-xs font-semibold inline-block text-pink-300">
                          {{ monsterHealth }}%
                        </span>
                    </div>
                  </div>
                  <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-pink-200">
                    <div :style="monsterBarStyles" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-500"></div>
                  </div>
                </div>
                <div class="relative pt-1">
                  <div class="flex mb-2 items-center justify-between">
                    <div>
                      <span class="lg:text-lg tracking-wider inline-block py-1 px-3 py-1 uppercase rounded-full text-pink-600 bg-pink-200  font-creepster">
                        Player Health
                      </span>
                    </div>
                    <div class="text-right">
                        <span class="text-xs font-semibold inline-block text-pink-300">
                          {{ playerHealth }}%
                        </span>
                    </div>
                  </div>
                  <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-pink-200">
                    <div :style="playerBarStyles" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-pink-500"></div>
                  </div>
                </div>
              </ul>
              <section id="controls" class="mt-3 mb-3">
                <section v-if="winner" class="flex flex-col items-center mt-5 font-creepster tracking-wide">
                  <h2>Game Over!</h2>
                  <h3 v-if="winner === 'monster'" class="text-pink-600 text-4xl">You lost!</h3>
                  <h3 v-else-if="winner === 'player'" class="text-green-400 text-4xl">You won!</h3>
                  <h3 v-else>It's a draw!</h3>
                  <button class="btn btn-gray" @click="startGame">Start New Game</button>
                </section>

                <div v-if="!winner">
                  <div class="flex justify-center mt-5">
                    <button class="rounded-md px-3 py-2 bg-pink-500 text-lg font-creepster tracking-wider text-white mx-1" @click="attackMonster">ATTACK</button>
                    <button class="rounded-md px-3 py-2 bg-pink-500 text-lg font-creepster tracking-wider text-white mx-1 disabled:opacity-50" :disabled="mayUseSpecialAttack" @click="specialAttackMonster">
                      SPECIAL ATTACK
                    </button>
                    <button class="rounded-md px-3 py-2 bg-pink-500 text-lg font-creepster tracking-wider text-white mx-1" @click="healPlayer">HEAL</button>
                    <button class="rounded-md px-3 py-2 bg-pink-500 text-lg font-creepster tracking-wider text-white mx-1" @click="surrender">SURRENDER</button>
                  </div>

                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!winner">
      <section id="log" class="mt-3 sm:flex sm:flex-col sm:items-center" v-if="logMessages.length > 0">
        <h2 class="text-4xl font-creepster tracking-wide">Battle Log</h2>
        <ul>
          <li v-for="logMessage in logMessages" :key="logMessage.id">
                <span class="text-lg font-creepster tracking-wider"
                      :class="{'log--player': logMessage.actionBy === 'player', 'log--monster': logMessage.actionBy === 'monster'}"
                >{{ logMessage.actionBy === 'player' ? 'Player' : 'Monster'
                  }}</span
                >
            <span v-if="logMessage.actionType === 'heal'">
                  heals himself for
                  <span class="log--heal">{{ logMessage.actionValue }}</span></span
            >
            <span v-else>
                  attacks and deals
                  <span class="log--damage">{{ logMessage.actionValue }}</span>
                </span>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MonsterSlayer",
  data() {
    return {
      playerHealth: 100,
      monsterHealth: 100,
      currentRound: 0,
      winner: null,
      logMessages: []
    };
  },
  computed: {
    monsterBarStyles() {
      if (this.monsterHealth < 0) {
        return { width: '0%' };
      }
      return { width: this.monsterHealth + '%' };
    },
    playerBarStyles() {
      if (this.playerHealth < 0) {
        return { width: '0%' };
      }
      return { width: this.playerHealth + '%' };
    },
    mayUseSpecialAttack() {
      return this.currentRound % 3 !== 0;
    },
  },
  watch: {
    playerHealth(value) {
      if (value <= 0 && this.monsterHealth <= 0) {
        // A draw
        this.winner = 'draw';
      } else if (value <= 0) {
        // Player lost
        this.winner = 'monster';
      }
    },
    monsterHealth(value) {
      if (value <= 0 && this.playerHealth <= 0) {
        // A draw
        this.winner = 'draw';
      } else if (value <= 0) {
        // Monster lost
        this.winner = 'player';
      }
    },
  },
  methods: {
    getRandomValue(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    startGame() {
      this.playerHealth = 100;
      this.monsterHealth = 100;
      this.winner = null;
      this.currentRound = 0;
      this.logMessages = [];
    },
    attackMonster() {
      this.currentRound++;
      const attackValue = this.getRandomValue(5, 12);
      this.monsterHealth -= attackValue;
      this.addLogMessage('player', 'attack', attackValue);
      this.attackPlayer();
    },
    attackPlayer() {
      const attackValue = this.getRandomValue(8, 15);
      this.playerHealth -= attackValue;
      this.addLogMessage('monster', 'attack', attackValue);
    },
    specialAttackMonster() {
      this.currentRound++;
      const attackValue = this.getRandomValue(10, 25);
      this.monsterHealth -= attackValue;
      this.addLogMessage('player', 'attack', attackValue);
      this.attackPlayer();
    },
    healPlayer() {
      this.currentRound++;
      const healValue = this.getRandomValue(8, 20);
      if (this.playerHealth + healValue > 100) {
        this.playerHealth = 100;
      } else {
        this.playerHealth += healValue;
      }
      this.addLogMessage('player', 'heal', healValue);
      this.attackPlayer();
    },
    surrender() {
      this.winner = 'monster';
    },
    addLogMessage(who, what, value) {
      this.logMessages.unshift({
        actionBy: who,
        actionType: what,
        actionValue: value,
        id: this.getRandomValue(1, 200),
      });
    }
  },
}
</script>